<div class="mt-3">
    <!-- additional info -->
    <div class="row kpiDetails">
        <div class="col-12 mb-1 additional-info" style="display: flex;">
            <div class="col-3">
                <label>Location : </label> {{perResults.testcaseExecSumm?.performanceRequest.location}}
            </div>
            <div class="col-3" *ngIf="perResults.testcaseExecSumm?.performanceRequest.iteration;else duration">
                <label>Iteration :</label> {{perResults.testcaseExecSumm?.performanceRequest.iterationCount}}
            </div>
            <ng-template #duration>
                <div class="col-3">
                    <label>Duration (D hh:mm:ss) :</label>
                    {{secondsToDhms(perResults.testcaseExecSumm?.performanceRequest.durationInSec)}}
                </div>
            </ng-template>

            <div class="col-3">
                <label>Testcase Type : </label> {{perResults.testcaseExecSumm?.performanceRequest.loadTestType}}
            </div>
            <div class="col-3">
                <label>Executed By : </label> {{perResults.testcaseExecSumm?.executedBy}}
            </div>
        </div>

        <div class="col-12 additional-info" style="display: flex;">
            <div class="col-3">
                <label>Start Time (PST) : </label>
                {{perResults.testcaseExecSumm?.performanceRequest.startTime | date: 'd-MM-yy, hh:mm:ss a' }}
            </div>
            <div class="col-3">
                <label>End Time (PST) : </label>
                {{perResults.testcaseExecSumm?.performanceRequest.endTime | date: 'd-MM-yy, hh:mm:ss a'}}
            </div>
            <div class="col text-truncate"><label> Environment : </label> <span
                    title="{{perResults.testcaseExecSumm?.performanceRequest.environmentMap?.name}}">
                    {{perResults.testcaseExecSumm?.performanceRequest.environmentMap?.name}}</span></div>
        </div>

        <div class="col-12 additional-info" style="display: flex;" *ngIf="perResults.testcaseExecSumm?.performanceRequest?.comments">
            <div class="col-3">
                <label>Comments : </label>{{perResults.testcaseExecSumm?.performanceRequest?.comments}}
            </div>
        </div>

        <div class="col-12 additional-info" style="display: flex;"
            *ngIf="perResults.testcaseExecSumm?.performanceRequest.errorMessage !== null">
            <div class="col" style="display: flex;">
                <div style="color: red; margin: 1px; font-size: 20px;">
                    {{perResults.testcaseExecSumm?.performanceRequest.errorMessage}} </div>
            </div>
        </div>
    </div>
    <div class="row mt-2">
        <div class='col-12 loadTestSection px-2 pt-2 pb-2'>
            <app-thread-group-page [newLoadTestCase]="perResults.testcaseExecSumm.testCase" [selectedLoadTestConfig]="perResults.testcaseExecSumm.loadtestConfig" [requestFromNewPerfDetails]="requestFromNewPerfDetails"></app-thread-group-page>
        </div>
    </div>
</div>